<button i18n="@@AddNew" nbButton outline status="success"  type="submit" (click)="onAssingPlanClicked()" class="btn-alternate btn-circle btn-xl" status="basic" 
    *ngIf="!showList">
    <nb-icon icon="person-add-outline"></nb-icon> <span>Assign to Client</span>
</button>
<nb-select placeholder="Select Client" *ngIf="showList"  (selectedChange)="onSelectItem($event)" style="min-width: 250px;">
   
        <nb-option *ngFor="let e of dataList" [value]="e.id"> {{ e.name }} </nb-option>
    
</nb-select>